import * as types from './constants';

// Create Code Bxgy
export const createCodeBxgyRequest = data => (
  { type: types.CREATE_CODE_BXGY_REQUEST, payload: data }
);

export const createCodeBxgyDone = data => (
  { type: types.CREATE_CODE_BXGY_DONE, payload: data }
);

export const createCodeBxgyFailed = errors => (
  { type: types.CREATE_CODE_BXGY_FAILED, payload: errors }
);

export const createCodeBxgyReset = () => (
  { type: types.CREATE_CODE_BXGY_RESET }
);